module.exports = __webpack_public_path__ + "5347949ad08589bbdb11a52cc01a6eca.svg";